/*
 * @file 
 * constants: Action names
 *
 * @author François Heremans
 * 
 */

export const SET_USER = "SET_USER"
export const SET_THEME = "SET_THEME"